import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useAuthContext } from 'context/AuthContext';
import Header from 'components/Header';
import Button from 'components/Button';
import Popup from 'components/Popup';
import TextInput from 'components/TextInput';
import Dropdown from 'components/Dropdown';
import DropdownSelect from 'components/DropdownSelect';
import Table from 'components/Table';
import axios from 'config/axios';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';

import './index.css';

function Classes() {
    const [classes, setClasses] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [search, setSearch] = useState('');
    const [formOpen, setFormOpen] = useState(false);
    const [success, setSuccess] = useState('');
    const [failed, setFailed] = useState('');
    const [name, setName] = useState('');
    const [organization, setOrganization] = useState(null);

    const { user } = useAuthContext();

    const closeForm = () => {
        setFormOpen(false);
        setOrganization(organizations[0]);
        setName('');
    }

    const navigate = useNavigate();
    const addClassRef = useOutsideClickHandler(closeForm);
    const successRef = useOutsideClickHandler(() => setSuccess(''));
    const failedRef = useOutsideClickHandler(() => setFailed(''));

    const getClasses = () => {
        axios.get('tutors/classes/')
            .then(res => {
                setClasses(res.data.classes);
                setOrganizations(res.data.organizations);
                if (res.data.organizations.length > 0) {
                    setOrganization(res.data.organizations[0]);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const addClass = () => {
        if (!name) {
            setFailed('Please make sure you have filled in all the required fields.');
        }
        else {
            axios.post('tutors/classes/add/', {
                    organization: organization?.id,
                    name: name
                })
                .then(res => {
                    closeForm();
                    setSuccess('Successfully added class!');
                    getClasses();
                })
                .catch(error => {
                    console.log(error);
                    setFailed('Failed to add class.');
                });
        }
    }

    useEffect(() => {
        getClasses();
    }, []);

    const newClass = (
        <Popup
            title='New class'
            primaryButtonText='Save'
            primaryButtonOnClick={addClass}
            secondaryButtonText='Cancel'
            secondaryButtonOnClick={closeForm}
            innerRef={addClassRef}
        >
            <div className='classes__add'>
                <TextInput
                    label='Class name'
                    placeholder='enter class name'
                    value={name}
                    onChange={event => setName(event.target.value)}
                    required
                />
                <Dropdown
                    label='Organization'
                    data={organizations}
                    dataKey='name'
                    placeholder='select organization'
                    value={organization?.name}
                    onSelect={value => setOrganization(value)}
                    required
                />
                {/* <DropdownSelect
                    label='Instructors'
                    data={instructors.map(instructor => (`${instructor.firstName} ${instructor.lastName}`))}
                    selected={instructors.map(instructor => (instructor.assigned))}
                    onSelect={value => assignInstructor(value)}
                /> */}
            </div>
        </Popup>
    );

    const successMessage = (
        <Popup
            title='Success'
            primaryButtonText='Close'
            primaryButtonOnClick={() => setSuccess('')}
            innerRef={successRef}
        >
            {success}
        </Popup>
    );

    const failedMessage = (
        <Popup
            title='Failed'
            primaryButtonText='Close'
            primaryButtonOnClick={() => setFailed('')}
            innerRef={failedRef}
        >
            {failed}
        </Popup>
    );

    return (
        <div className='classes'>
            <Helmet>
                <title>
                    All Classes - Test Center Admin
                </title>
            </Helmet>
            <Header title='All Classes' />
            {failed
                ? failedMessage
                : success
                ? successMessage
                : formOpen
                ? newClass
                : <></>
            }
            <div className='classes__bar'>
                <TextInput
                    className='classes__search'
                    placeholder='search class'
                    value={search}
                    onChange={event => setSearch(event.target.value)}
                />
                {user.role === 'Admin' &&
                    <div className='classes__buttons'>
                        <Button onClick={() => setFormOpen(!formOpen)}>
                            New class
                        </Button>
                    </div>
                }
            </div>
            <Table 
                header={['Name', 'Organization', '# Students', '# Tests', 'Created At']}
                rows={classes.filter(groupClass => (
                    !search ||
                    groupClass.name?.toLowerCase().includes(search.toLowerCase())
                )).map(groupClass => ([
                    groupClass.name,
                    groupClass.organization,
                    groupClass.numStudents,
                    groupClass.numTests,
                    new Date(groupClass.createdAt).toLocaleDateString()
                ]))}
                onSelectCell={classes.filter(groupClass => (
                    !search ||
                    groupClass.name?.toLowerCase().includes(search.toLowerCase())
                )).map(groupClass => ([
                    () => navigate(`/classes/${groupClass.id}`),
                    null,
                    null,
                    null,
                    null
                ]))}
            />
        </div>
    );
}

export default Classes;